import React from "react";

export const LazyRedBoxPlayerBridge = React.lazy(
    () => import(/* webpackChunkName: "RedBox" */ "./Player")
);
